import styled, { css } from 'styled-components';
import { Body } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import { FiAlignJustify } from 'react-icons/fi';
import { ItemStatus } from 'model/menu';

// TODO: TFR-44 move to icon group
export const DraggableIcon = styled(FiAlignJustify)`
  display: none;
  position: absolute;
  left: -2.125rem;
  width: 1.25rem;
  height: 1.25rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 5rem 1fr 1fr 1fr 8rem 14rem;
  align-items: center;
  height: auto;
  height: 4.5rem;
  padding: 0.25rem 2rem;
  border-radius: 1.25rem;

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.gray1};

    ${DraggableIcon} {
      display: initial;
    }
  }
`;

// TODO: TFR-44 move to container group
export const Fragment = styled.div``;

export const TextMenuStatus = styled.div<{ value: ItemStatus }>`
  border-radius: 1.5rem;
  padding: 0.75rem 1.25rem;
  height: 3rem;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ value, theme }) => {
    switch (value) {
      case 'SUSPEND_DAY':
        return css`
           {
            background: ${theme.colors.yellowLight};
            color: ${theme.colors.yellowDark};
          }
        `;
      case 'ACTIVE':
        return css`
           {
            background: ${theme.colors.greenExtraLight};
            color: ${theme.colors.greenDark};
          }
        `;
      default:
      case 'SUSPEND_INDEFINITE':
        return css`
           {
            background: ${theme.colors.redExtraLight};
            color: ${theme.colors.redDark};
          }
        `;
    }
  }}
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const TextMedium = styled(Body)``;

// TODO: TFR-44 move to typography group
export const TextSemi = styled(Body)`
  font-weight: 600;
`;
